import { Module } from "vuex"
import { AuthRootState, TokenData, UserData, RootState } from "@/store/types"
import { callApi } from "@/services/api"
import { Router } from "vue-router"

const authStore: Module<AuthRootState, RootState> = {
  namespaced: true,

  state: () => ({
    user: {} as UserData,
    tokenData: {} as TokenData,
    showLoginModal: false,
    redirectAfterLogin: null,
    promiseFetchingProfile: null,
  }),

  getters: {
    user: (state) => state.user,
    tokenData: (state) => state.tokenData,
    showLoginModal: (state) => state.showLoginModal,
    isAuthenticated: () => !!localStorage.getItem("access_token"),
    promiseFetchingProfile: (state) => state.promiseFetchingProfile,
  },

  mutations: {
    SET_USER(state, user: UserData) {
      state.user = user

      localStorage.setItem("user", JSON.stringify(user))
    },
    SET_TOKEN_DATA(state, tokenData: TokenData) {
      state.tokenData = tokenData
    },
    CLEAR_AUTH(state) {
      state.user = {} as UserData
      state.tokenData = {} as TokenData
    },
    SHOW_LOGIN_MODAL(state, value) {
      if (!value) {
        state.redirectAfterLogin = null
      }
      state.showLoginModal = value
    },
    SET_REDIRECT_AFTER_LOGIN(state, path) {
      state.redirectAfterLogin = path
    },
    SET_FETCHING_PROFILE(state, value: Promise<void>) {
      state.promiseFetchingProfile = value
    },
  },

  actions: {
    async logout({ commit }) {
      await callApi.logout()

      localStorage.removeItem("access_token")
      localStorage.removeItem("refresh_token")
      localStorage.removeItem("user")

      commit("CLEAR_AUTH")

      window.location.href = "/"
    },

    setUser({ commit }, user: UserData) {
      commit("SET_USER", user)
    },

    setTokenData({ commit }, tokenData: TokenData) {
      commit("SET_TOKEN_DATA", tokenData)
    },

    async handleRedirectAfterLogin({ state, commit }, router: Router) {
      if (state.redirectAfterLogin) {
        await router.push(state.redirectAfterLogin)
        commit("SET_REDIRECT_AFTER_LOGIN", null)
      }
    },
  },
}

export default authStore
